var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /** @format */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";

export class ShowSidepanelMenu extends Component {
  render() {
    const { panelIsOpen, openPanel, active } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: active ? 'active' : '' }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: !panelIsOpen }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn btn-primary", onClick: (e) => openPanel(e) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "columns" })
      )
      )
      ));

  }
}

ShowSidepanelMenu.defaultProps = {
  active: false
};